export default "__VITE_ASSET__CVFOtzko__"